export enum TileTypes {
	Started,
	OnGoing,
	Finished,
	Notification,
	Waiting
}
